// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"5e18e83d","253":"33a7a7ec","359":"1601cc4f","453":"7cdc0bac","861":"fe9f96a6","886":"910b6523","890":"28d8930f"}[chunkId] + ".chunk.js";
};